import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SlugNameService {

  constructor() { }

	getProductName(product: any) {
		const parentId = product?.parent_id || product?.id;
		if (product?.slug) {
			return product?.slug + "/" + parentId
		}
		else{
			const nameRouting = product.name_en
					.replace(/[^\w\s]/gi, "-")
					.replace(/ /g, "-");
			return nameRouting + "/" + parentId;
		}
	}
}
